import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { FragmentMessages } from "../../common/fragment-messages";
import PuntedByPositionPref from "./position-pref/punted-by-position-pref";

export default class Punt extends Fragment {
    constructor(puntedBy, puntedTo) {
        super();

        this.puntedBy = puntedBy;
        this.puntedTo = puntedTo;

        this.requiredData = [
            {
                name: "puntedBy",
                type: FragmentDataType.Player,
                displayName: "Punted By",
                title: (team) => `Punted By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new PuntedByPositionPref(play, this).resolve()
            },
            {
                name: "puntedTo",
                type: FragmentDataType.FieldPosition,
                displayName: "Punted To",
                title: "Punted To",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    getFragmentTeamId() {
        return this.puntedBy?.teamId;
    }

    getPlayers() {
        return [this.puntedBy];
    }

    getFieldPosition() {
        return this.puntedTo;
    }

    getPredicate() {
        return "punted";
    }

    summarize(summaryContext, stringifier) {
        const message = `${stringifier.firstInitial(
            this.puntedBy
        )} ${this.getPredicate()} ${stringifier.gain(
            summaryContext,
            summaryContext.fieldPosition,
            this.puntedTo,
            false
        )},`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.fieldPosition = this.puntedTo;
        summaryContext.homeTeamHasPossession =
            !summaryContext.homeTeamHasPossession;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            puntedBy: playerReducer(this.puntedBy)
        };
    }
}
